export const RoleEnum = Object.freeze({
    STUDENT: 'student',
    INFRASTRUCTURE: 'infrastructure',
    COUNSELING: 'counseling',
    CURRICULUM: 'curriculum',
    ADMIN: 'admin',
    STAFF: 'staff',
    RECEPTIONIST: 'receptionist',
    ACCOUNTANT: 'accountant',
    STUDENTSHIP: 'studentship',
    TEACHER: 'teacher',
    PARENTS: 'parents',
    SUPER_ADMIN: 'super-admin',
    FOUNDATION: 'foundation',
    HEADMASTER: 'headmaster',
});

export const MOBILE_ALLOWED_ROLES = Object.freeze([
    RoleEnum.ADMIN,
    RoleEnum.TEACHER,
    RoleEnum.STUDENT,
    RoleEnum.PARENTS,
    'admin',
    'Administrator',
    'Guru',
    'Siswa',
    'Orang Tua',
    'wali',
    'parent',
]);

export function hasPermission(permissionName, userOrProfile = null) {
    if (!permissionName) return true;
    try {
        let u = userOrProfile;
        if (!u) {
            try {
                u = JSON.parse(localStorage.getItem('user') || '{}');
            } catch (err) {
                u = {};
            }
        }
        let profile = {};
        try {
            const p = JSON.parse(localStorage.getItem('profile') || '{}');
            profile = p?.profile || p || {};
        } catch (err) {
            profile = {};
        }

        const roleId = Number(u?.role_id || profile?.default_role_id || profile?.role_id);
        const roleNames = [
            u?.role?.name,
            u?.role,
            profile?.role?.name,
            profile?.role,
            ...(u?.roles || []).map(r => (typeof r === 'object' ? r.name : r)),
            ...(profile?.roles || []).map(r => (typeof r === 'object' ? r.name : r)),
        ].filter(Boolean).map(s => String(s).toLowerCase());

        // Admin & Super Admin always bypass permission checks
        if (roleId === 1 || roleNames.some(r => r.includes('admin') || r.includes('super'))) return true;

        const perms = profile?.permissions || u?.permissions || [];
        if (Array.isArray(permissionName)) {
            return permissionName.some(p => perms.includes(p));
        }
        return perms.includes(permissionName);
    } catch (err) {
        return false;
    }
}

export function isMobileRoleAllowed(userOrRoles) {
    if (!userOrRoles) return false;
    let roles = [];
    if (Array.isArray(userOrRoles)) {
        roles = userOrRoles;
    } else if (userOrRoles.roles && Array.isArray(userOrRoles.roles)) {
        roles = userOrRoles.roles.map(r => (typeof r === 'object' ? r.name : r));
    } else if (userOrRoles.role) {
        roles = [userOrRoles.role];
    } else if (userOrRoles.role_name) {
        roles = [userOrRoles.role_name];
    }
    const allowedLower = MOBILE_ALLOWED_ROLES.map(r => String(r).toLowerCase());
    return roles.some(r => allowedLower.includes(String(r).toLowerCase()));
}
